import { render, staticRenderFns } from "./RiskSurveyLighting.vue?vue&type=template&id=b0fb1c9c&"
import script from "./RiskSurveyLighting.vue?vue&type=script&lang=js&"
export * from "./RiskSurveyLighting.vue?vue&type=script&lang=js&"
import style0 from "./RiskSurveyLighting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports